import React, { useState } from 'react';
import { DEMO_PROFILES, EXPLORE_CATEGORIES } from '../data/demo';
import { FiSearch } from 'react-icons/fi';

const Explore = () => {
  const [activeCategory, setActiveCategory] = useState('trending');
  const [search, setSearch] = useState('');

  return (
    <div style={{ minHeight: '100vh', background: '#08080C', paddingBottom: 90 }}>
      <div style={{ padding: '16px 20px 0' }}>
        <h1 style={{ fontSize: 26, fontWeight: 800, marginBottom: 16 }}>Explore</h1>
        <div style={{ position: 'relative', marginBottom: 16 }}>
          <FiSearch style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: '#71717A' }} size={18} />
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search people, interests..."
            style={{
              width: '100%', padding: '14px 16px 14px 42px',
              background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.06)',
              borderRadius: 14, color: '#FFFFFF', fontSize: 15, fontFamily: 'Inter',
              outline: 'none',
            }} />
        </div>
        <div style={{ display: 'flex', gap: 8, overflowX: 'auto', paddingBottom: 16, scrollbarWidth: 'none' }}>
          {EXPLORE_CATEGORIES.map(c => (
            <button key={c.id} onClick={() => setActiveCategory(c.id)} style={{
              flexShrink: 0, padding: '8px 16px', borderRadius: 12,
              background: activeCategory === c.id ? `${c.color}15` : 'rgba(255,255,255,0.04)',
              border: `1px solid ${activeCategory === c.id ? c.color + '40' : 'rgba(255,255,255,0.06)'}`,
              color: activeCategory === c.id ? c.color : '#A1A1AA',
              fontSize: 13, fontWeight: 500, cursor: 'pointer', fontFamily: 'Inter',
              display: 'flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap',
            }}>{c.icon} {c.label}</button>
          ))}
        </div>
      </div>

      <div style={{ padding: '0 16px' }}>
        <h3 style={{ fontSize: 16, fontWeight: 600, padding: '0 4px 12px' }}>Trending Near You</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12 }}>
          {DEMO_PROFILES.map(p => (
            <div key={p._id} style={{
              borderRadius: 20, overflow: 'hidden', position: 'relative', aspectRatio: 3/4,
              background: '#111118',
            }}>
              <img src={p.photos?.[0]} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                onError={(e) => { e.target.src = `https://ui-avatars.com/api/?name=${p.name}&background=1A1A24&color=FF3D71&size=400`; }} />
              <div style={{
                position: 'absolute', bottom: 0, left: 0, right: 0,
                background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
                padding: '40px 12px 12px',
              }}>
                <h4 style={{ fontSize: 15, fontWeight: 600 }}>{p.name}, {new Date().getFullYear() - new Date(p.dob).getFullYear()}</h4>
                <p style={{ fontSize: 12, color: '#A1A1AA' }}>{p.city}</p>
              </div>
              {p.compatibility && (
                <div style={{
                  position: 'absolute', top: 10, right: 10,
                  padding: '4px 8px', borderRadius: 8,
                  background: 'rgba(0,0,0,0.5)', backdropFilter: 'blur(10px)',
                  fontSize: 11, fontWeight: 600, color: '#FF3D71',
                }}>❤️ {p.compatibility}%</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Explore;
